import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from './DashboardDataContext';

function normalizeStatusClass(raw?: string) {
  const s = String(raw || '').trim().toUpperCase();
  if (!s) return 'open';
  if (s.includes('PROGRESS')) return 'inprogress';
  if (s.includes('BOOK')) return 'booked';
  if (s.includes('CANCEL')) return 'cancelled';
  if (s.includes('CLOSE')) return 'closed';
  if (s.includes('OPEN')) return 'open';
  return s.toLowerCase().replace(/\s/g, '');
}

function normalizeStatusLabel(raw?: string) {
  const s = String(raw || '').trim().toUpperCase();
  if (s.includes('PROGRESS')) return 'In Progress';
  if (s.includes('BOOK')) return 'Booked';
  if (s.includes('CANCEL')) return 'Cancelled';
  if (s.includes('CLOSE')) return 'Closed';
  if (s.includes('OPEN')) return 'Open';
  return raw || '—';
}

const QueriesComponent = () => {
  const [queries, setQueries] = useState<any[]>([]);
  const formatRelative = (iso?: string) => {
    if (!iso) return '—';
    const d = new Date(iso);
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return 'just now';
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const days = Math.floor(hr / 24);
    return `${days}d ago`;
  };
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.recentQueries || []).map((q:any)=>({
      name: q.customer?.name || '—',
      type: q.type,
      status: q.status,
      lastUpdated: q.queryDate,
    }));
    setQueries(list);
  }, [data]);

  return (
    <div className="card">
      <h4 className="card-title">Recent Queries</h4>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            {queries.map((q, i) => (
              <tr key={i}>
                <td>{q.name}</td>
                <td>{q.type}</td>
                <td>
                  <span className={`pill ${normalizeStatusClass(q.status)}`}>{normalizeStatusLabel(q.status)}</span>
                </td>
                <td>{formatRelative(q.lastUpdated)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QueriesComponent;
